(() => {
  const SESSION_DISMISS_KEY = 'salted-newsletter-popup:dismissed';
  const OPEN_DELAY_MS = 3000;

  const setDismissed = () => {
    try {
      window.sessionStorage.setItem(SESSION_DISMISS_KEY, '1');
    } catch (error) {
      // no-op if storage is unavailable
    }
  };

  const isDismissed = () => {
    try {
      return window.sessionStorage.getItem(SESSION_DISMISS_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const initPopup = () => {
    const root = document.querySelector('[data-newsletter-popup-root]');
    if (!root || root.dataset.popupReady === 'true') return;

    root.dataset.popupReady = 'true';

    const dialog = root.querySelector('.newsletter-popup__dialog');
    const overlay = root.querySelector('[data-newsletter-popup-overlay]');
    const closeButton = root.querySelector('[data-newsletter-popup-close]');
    const hasFormState = Boolean(
      root.querySelector('[data-newsletter-popup-success="true"], [data-newsletter-popup-error="true"]')
    );

    let isOpen = false;

    const openPopup = (force = false) => {
      if (isOpen) return;
      if (!force && isDismissed()) return;

      root.hidden = false;
      document.body.classList.add('newsletter-popup-open');
      isOpen = true;

      window.requestAnimationFrame(() => {
        const focusTarget =
          root.querySelector('input[type="email"]') ||
          root.querySelector('button[type="submit"]') ||
          dialog;

        if (focusTarget) {
          focusTarget.focus({ preventScroll: true });
        }
      });
    };

    const closePopup = (persist = true) => {
      if (!isOpen) return;
      if (persist) setDismissed();

      root.hidden = true;
      document.body.classList.remove('newsletter-popup-open');
      isOpen = false;
    };

    if (closeButton) {
      closeButton.addEventListener('click', () => closePopup(true));
    }

    if (overlay) {
      overlay.addEventListener('click', () => closePopup(true));
    }

    document.addEventListener('keydown', (event) => {
      if (!isOpen) return;
      if ((event.key || '').toLowerCase() !== 'escape') return;
      closePopup(true);
    });

    if (hasFormState) {
      openPopup(true);
      return;
    }

    const queueOpen = () => {
      window.setTimeout(() => {
        openPopup(false);
      }, OPEN_DELAY_MS);
    };

    if (document.readyState === 'complete') {
      queueOpen();
    } else {
      window.addEventListener('load', queueOpen, { once: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    initPopup();
  }
})();
